import PricingImport from "./IPricing.json";

export const abi = PricingImport.abi;
export * from "./Pricing";


